import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IntroComponent } from './intro/intro.component';
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from "./home/home.component";
import {AuthGuard} from "./auth/auth.guard";

const routes = [
  { path: '', redirectTo: '/intro', pathMatch: 'full' },
  { path: 'intro', component: IntroComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent,canActivate:[AuthGuard] },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {


}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts